import { render, staticRenderFns } from "./IonlineRealmModal.vue?vue&type=template&id=79b0b8ed&scoped=true&"
import script from "./IonlineRealmModal.vue?vue&type=script&lang=js&"
export * from "./IonlineRealmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0b8ed",
  null
  
)

export default component.exports